import classes from "./ImageComponent.module.css";

export default function ImageComponent(props: any) {
  return <img className={classes.image} alt={props.alt} {...props} />;
}
